<template>
    <ModalComponent
        :name="'test-venta-warning-' + evento.id + '-' + sesion.id"
        title="ENLACE PARA USO INTERNO"
        @close="close"
    >
        <div class="row">
            <div class="col-12">
                <p class="text-justify text-lg" style="word-spacing: -2px;">
                    Este enlace es solo para uso interno.<br/>
                    No se debe publicar en ningún sitio web ni debe distribuirse al público general.
                </p>
            </div>

            <div class="col-12">
                <div class="d-md-flex justify-content-center text-center">
                    <Button v-if="!evento.solo_abonados" data-cy="test-venta-normal" class="btn btn-primary" @click="openLink(ventaNormal)">
                        Ir a la venta normal
                    </Button>

                    <Button v-if="evento.solo_abonados || evento.descuento_abonado" data-cy="test-venta-abonado" class="btn btn-primary ml-md-2 mt-2 mt-md-0" @click="openLink(ventaAbonado)">
                        Ir a la venta como abonado
                    </Button>

                    <Button v-if="!evento.solo_abonados && evento.amigo_abonado" data-cy="test-venta-amigoabonado" class="btn btn-primary ml-md-2 mt-2 mt-md-0" @click="openLink(ventaAmigoAbonado)">
                        Ir a la venta como amigo abonado
                    </Button>
                </div>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: {
            evento: Object,
            sesion: Object
        },
        computed: {
            ventaNormal() {
                return `/eventos/${this.evento?.id}/${this.sesion?.id}/${this.evento?.slug}?venta_online=test`;
            },
            ventaAbonado() {
                return `/eventos/${this.evento?.id}/${this.sesion?.id}/abonados?venta_online=test`;
            },
            ventaAmigoAbonado() {
                return `/eventos/${this.evento?.id}/${this.sesion?.id}/amigos-abonados?venta_online=test`;
            }
        },
        methods: {
            close() {
                this.$emit('close', 'test-venta-warning-' + this.evento.id + '-' + this.sesion.id);
            },
            openLink(link) {
                this.$router.push(link);
            }
        },
        components: {
            ModalComponent
        },
    }
</script>
